import logo from './logo.svg';
import './App.css';
import Home from './Pages/Home';
import Dashboard from './Pages/Dashboard/dashboard';
import Stake from './Pages/Dashboard/stake';
import Together from './Pages/Dashboard/together';
import PageNotFound from './Pages/404/error'
import * as ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="stake" element={<Stake />} />
          <Route path="together" element={<Together />} />
          <Route path="*" element={<PageNotFound/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
